var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditPicGold(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47444 4.47444 0 10 0C15.5233 0 19.9978 4.47444 20 10C19.9978 15.5233 15.5233 19.9978 10 20C4.47444 19.9978 0 15.5233 0 10ZM2.35111 10C2.36 14.2211 5.77667 17.6378 10 17.6478C14.2211 17.6378 17.6378 14.2211 17.6478 10C17.6378 5.77667 14.2211 2.36 10 2.35C5.77667 2.36 2.36 5.77667 2.35111 10Z",
    fill: "#816F4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88888 14.4444H5.55554V11.1111L8.88888 14.4444Z",
    fill: "#816F4B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0005 13.3328L15.556 7.77734L12.2224 4.44376L6.66694 9.99921L10.0005 13.3328Z",
    fill: "#816F4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPicGold);
export default __webpack_public_path__ + "static/media/edit-pic_gold.66b3c2c60d9e0b8b13e93d0fbbcbb2fb.svg";
export { ForwardRef as ReactComponent };